export enum StructureTypeEnum {
  SINGLE = 'SINGLE',
  SEPARATE_WITH_SUMMARY = 'SEPARATE_WITH_SUMMARY',
  SEPARATE_WITHOUT_SUMMARY = 'SEPARATE_WITHOUT_SUMMARY',
}
